import formatString from 'string-format'

const cleanFormatString = (url: string) => {
  const qIndex = url.indexOf('?')
  if (qIndex >= 0) {
    return (
      url.slice(0, qIndex + 1) +
      url
        .slice(qIndex + 1)
        .replace(/[^=&]+=(&|$)/g, '')
        .replace(/&$/, '')
    )
  }
  return url
}

export const getTogetherPath = (
  path: string,
  params?: { [key: string]: string | number },
  version?: string,
) => {
  const formattedPath = formatString(path, {
    website_url: 'https://marrybaby.vn',
    ...params,
  })
  return (
    process.env.NEXT_PUBLIC_TOGETHER_API +
    `api/${version || 'v1'}/` +
    cleanFormatString(formattedPath)
  )
}
